module.exports = __webpack_public_path__ + "e3736bcd33a1be9cf074c5de6c8ecdd7.pdf";